<template>
    <div @click.self="$emit('close')" class="backdrop-blur-[7px] fixed inset-0 z-10" style="background-color: rgba(53, 53, 53, 0.3)"></div>
    <div class="fixed shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] top-[50%] left-[50%] p-4 bg-[#252526] rounded-[10px] w-[320px] z-20 translate-x-[-50%] translate-y-[-50%]">
        <div class="text-center mb-3 text-[#FFF]">
            Ви дійсно хочете видалити файл <strong>{{ file?.file_name }}</strong>?
        </div>
        <div class="flex justify-between">
            <button @click="$emit('confirm')" class="bg-[#DA4167] hover:bg-opacity-90 text-white px-4 py-1 rounded-[10px]">
                Так
            </button>
            <button @click="$emit('close')" class="px-4 py-1 rounded-[10px] bg-[#BD9135] text-white">
                Ні
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'delete-file-modal',

        props: {
            file: {
                type: Object,
                default: null
            }
        }
    }
</script>
